import React, { useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { FormInput, FormInputProps } from 'modules';
import { CreditorListQuery } from 'queries/Creditor/Creditor';
import SearchResult from './components/SearchResults';
import useOutsideClick from 'helpers/useOutsideClick';
import './styles.scss';

interface CreditorSelectProps extends FormInputProps {
  onChangeCreditor: (creditor: GQL.ICreditor) => void;
}

const CreditorSelect = (props: CreditorSelectProps) => {
  const wrapperRef = React.useRef<HTMLDivElement>(null);

  const [resultOpened, setResultOpened] = useState(false);
  const [searchQuery, setSearchQuery] = useState(props.value || '');

  const { data, loading } = useQuery(CreditorListQuery, {
    variables: {
      where: {
        fulltext: searchQuery,
      },
      limit: {
        limit: 20,
      },
    },
  });

  const onChange = (e: React.ChangeEvent) => {
    const { value } = e.target as HTMLInputElement;
    setSearchQuery(value);
    setResultOpened(true);
    if (props.onChange) {
      props.onChange(e);
    }
  };

  const onChoise = (creditor: GQL.ICreditor) => {
    if (creditor.jmeno) {
      setSearchQuery(creditor.jmeno);
    }
    setResultOpened(false);
    if (props.onChange) {
      props.onChange({
        target: {
          name: props.name,
          value: creditor?.jmeno,
        },
      });
    }
  };

  useOutsideClick(wrapperRef, () => {
    setResultOpened(false);
  });

  return (
    <div className="creditorSelect" ref={wrapperRef}>
      <FormInput {...props} type="text" value={searchQuery} onChange={onChange} />
      {resultOpened && <SearchResult loading={loading} data={data?.creditorList} onClick={onChoise} />}
    </div>
  );
};

export default CreditorSelect;
